module.exports = __webpack_public_path__ + "img/tag_rate@2x.160b8928.png";